<template>
  <div class="tabs-head">
    <Breadcrumb v-if="!isFabric">
      <BreadcrumbItem to="/nodes">{{ this.$t('nodes.nodes') }}</BreadcrumbItem>
      <BreadcrumbItem>
        <Select
          v-model="selectNode"
          class="node-select"
          label-in-value
          :placeholder="$t('nodes.currentNode')"
          @on-change="handleNodeChange"
        >
          <Option v-for="node in nodes" :key="node.value" :value="node.value" :label="node.label"> </Option>
        </Select>
      </BreadcrumbItem>
    </Breadcrumb>
    <div>
      <a
        v-for="tab in tabsData"
        :key="tab.id"
        class="crud-title"
        href="javascript:;"
        :class="{ active: activeTab === tab.id }"
        @click="goToTab(tab)"
      >
        {{ tab.name }}
      </a>
      <slot name="custom-tab"></slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TabsCardHead',

  props: {
    activeTab: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      selectNode: '',
    }
  },

  computed: {
    ...mapState(['isFabric']),
    currentNode() {
      return this.$store.state.currentNode
    },
    nodes() {
      return this.$store.state.nodes
    },
    nodeID() {
      const id = this.$route.params.id || this.$store.state.currentNode.id
      return id
    },
    tabsData() {
      return [
        { id: 'source', name: this.$t('streams.source') },
        { id: 'rules', name: this.$t('rules.rules') },
        { id: 'extension', name: this.$t('extension.extension') },
        { id: 'configuration', name: this.$t('configuration.configuration') },
        { id: 'system', name: this.$t('system.system') },
      ]
    },
  },

  created() {
    this.selectNode = this.currentNode.id
  },

  methods: {
    ...mapActions(['SET_CURRENTNODE']),

    handleNodeChange(val) {
      if (!val) {
        return
      }
      const { value: id, label: name } = val
      this.SET_CURRENTNODE({ id, name, refresh: true })
      this.$router.replace({
        name: this.activeTab,
        params: {
          id,
        },
      })
    },
    goToTab(tab) {
      this.$router.push({
        name: tab.id,
        params: {
          id: this.nodeID,
        },
      })
    },
  },
}
</script>

<style lang="scss">
.tabs-head {
  margin-bottom: 20px;
  border-bottom: 2px solid var(--color-border-tab);
  .crud-title {
    color: #a2a2a2;
    width: 100px;
    height: auto;
    padding-bottom: 6px;
    line-height: 32px;
    text-align: center;
    background-color: transparent;
    display: inline-block;
    font-size: 14px;
    position: relative;
    top: 1px;
    &:hover {
      border-bottom: 2px solid #a8acb636;
    }
    &.active {
      color: #34c388 !important;
      border-bottom: 2px solid #2fc285;
    }
  }
  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 18px;
    height: 28px;
    line-height: 28px;
  }
  .ivu-select {
    width: 230px;
    .ivu-select-visible .ivu-select-selection,
    .ivu-select-selection {
      border: none;
    }
    .ivu-select-arrow {
      top: 14px;
    }
  }
}
</style>
